import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const AdminSLogoInverse32Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M64 272L1216 67v1914L64 1782V272zm613 347q-54 0-98 17t-75 50-48 76-17 98q0 59 18 98t49 69 68 55 78 57q17 14 26 33t9 42q0 38-23 58t-60 20q-23 0-46-6t-44-18-40-28-32-35v173q39 26 84 40t93 14q50 0 91-15t70-45 44-70 16-92q0-62-19-104t-49-72-62-50-63-41-48-43-20-58q0-22 8-38t23-26 33-14 39-5q33 0 69 13t60 38V641q-31-11-66-16t-68-6zm731 405q0 26-10 49t-27 41-41 28-50 10V897q27 0 50 10t40 27 28 40 10 50zm616 86l-63 241-212-28q-17 26-35 50t-41 46l74 192-216 126-128-168q-60 15-123 15v-210q72 0 135-27t111-75 74-110 28-136q0-72-27-135t-75-111-110-75-136-28V461h5l79-180 241 64-27 205q27 17 52 37t48 44l188-72 125 215-167 129q13 59 13 124l187 83z" />
    </svg>
  ),
  displayName: 'AdminSLogoInverse32Icon',
});

export default AdminSLogoInverse32Icon;
